<form [formGroup]="delayForm">
  <div class="delay-field">
    <span *ngIf="waitLabelTranslationKey" class="wait-for">{{ waitLabelTranslationKey | translate }}</span>

    <glxy-form-field [required]="true" class="delay-input">
      <input matInput [formControl]="delayForm.controls.sleep" type="number" min="1" />
      <glxy-error class="error-hint" *ngIf="delayForm.errors?.overAYear">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.OVER_YEAR_ERROR' | translate }}
      </glxy-error>
      <glxy-error class="error-hint" *ngIf="delayForm.errors?.lessThanOne">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.LESS_THAN_ONE' | translate }}
      </glxy-error>
    </glxy-form-field>

    <glxy-form-field [required]="true" class="delay-period">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.UNIT' | translate }} </glxy-label>
      <mat-select [formControl]="delayForm.controls.timeUnit" [required]="true">
        <mat-option [value]="TimeUnit.Minute">
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.MINUTES' | translate }}
        </mat-option>
        <mat-option [value]="TimeUnit.Hour">
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.HOURS' | translate }}
        </mat-option>
        <mat-option [value]="TimeUnit.Day">
          {{ 'AUTOMATIONS.EDITOR.TASKS.DELAY.TIME_PERIOD.DAYS' | translate }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
  </div>
</form>
